import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Colors } from 'modules/theme';

const MenuItemRoot = styled(MenuItem)({
  minHeight: 0,
  padding: '12px 24px',
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '24px',
  color: Colors.darkBlue,
  '&::after': {
    background: 'none',
  },
});

function AccountDropdownMenuItem({ text, onClick }) {
  return <MenuItemRoot onClick={onClick}>{text}</MenuItemRoot>;
}

AccountDropdownMenuItem.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
};

export default memo(AccountDropdownMenuItem);
